import { createSlice } from '@reduxjs/toolkit';
import { IPageState } from '../types';
import { getPage } from '../../service/api';

const initialState: IPageState = {
  page: null,
  pending: false,
  error: null,
};

export const pageSlice = createSlice({
  name: 'pageSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPage.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getPage.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getPage.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default pageSlice.reducer;
